var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('upload-btn',{staticStyle:{"padding-left":"0px"},attrs:{"title":_vm.labelText,"color":"secondary"},on:{"file-update":_vm.update}})}
var staticRenderFns = []

export { render, staticRenderFns }